import { FC } from 'react';
import { BareSvg } from '@/lib/bareSvg';
import { useNavigationItems } from '@/hooks/useNavigationItems';
import IcCommunity from '@/assets/icons/ic-community.svg';
import { StanLink } from '@/components';
import { useCommunityUrl } from '@/features/communities';
import { useAskStanley } from '@/features/ask-stanley';
import { MENUITEM_IDS } from '@/lib/constants';
import { useMobileModalNavigation } from '../hooks';

interface OtherSectionProps {
    onClose: () => void;
}

export const OtherSection: FC<OtherSectionProps> = ({ onClose }) => {
    const { adminItems, accountItems } = useNavigationItems();
    const { openChat } = useAskStanley();
    const { handleNavigation } = useMobileModalNavigation({ onClose });
    const communityUrl = useCommunityUrl();

    const handleItemClick = (e: React.MouseEvent, itemId: string, redirect?: boolean, route?: string) => {
        e.preventDefault();

        // Special handling for Ask Stanley - open chat instead of navigating
        if (itemId === MENUITEM_IDS.ASK_STANLEY) {
            openChat('mobile_more_modal');
            onClose();
            return;
        }

        // Use shared navigation handler for all other items
        handleNavigation(redirect, route);
    };

    return (
        <div>
            <h3 className='text-dark mb-4'>Other</h3>
            <div className='space-y-3'>
                {communityUrl && (
                    <a
                        href={communityUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => handleNavigation()}
                        className='shadow-nucleus-elevation-medium flex w-full items-center gap-4 rounded-lg bg-white p-3 text-left transition-colors hover:bg-gray-50'
                    >
                        <div className='bg-brand-subtle shadow-nucleus-elevation-low flex size-9 items-center justify-center rounded-lg'>
                            <IcCommunity className='text-dark size-5' />
                        </div>
                        <span className='text-label-sm-bold text-dark'>Community</span>
                    </a>
                )}
                {[...adminItems, ...accountItems].map(item => (
                    <StanLink
                        key={item.id}
                        to={item.route}
                        onClick={e => handleItemClick(e, item.id, item.redirect, item.route)}
                        className='flex w-full items-center gap-4 rounded-lg bg-white p-3 text-left shadow-md'
                    >
                        <div className='bg-brand-subtle flex size-9 items-center justify-center rounded-lg shadow-sm'>
                            <BareSvg SvgComponent={item.icon} className='text-dark size-5' />
                        </div>
                        <span className='text-label-sm-bold text-dark'>{item.title}</span>
                    </StanLink>
                ))}
            </div>
        </div>
    );
};
